import { render } from "./MultiDropdown.vue?vue&type=template&id=2a96347d&scoped=true"
import script from "./MultiDropdown.vue?vue&type=script&lang=js"
export * from "./MultiDropdown.vue?vue&type=script&lang=js"

import "./MultiDropdown.vue?vue&type=style&index=0&id=2a96347d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a96347d"]])

export default __exports__